import script from "./SavePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SavePage.vue?vue&type=script&setup=true&lang=ts"

import "./SavePage.vue?vue&type=style&index=0&id=4929ca49&lang=css"

const __exports__ = script;

export default __exports__